import { useNavigate } from "react-router-dom";

/**
 * Sticky bar che mostra il conteggio degli alunni selezionati con un bottone
 * "📧 Invia mail (N)" che apre Comunicazioni con la lista pre-selezionata
 * (via URL query string ?codes=...&label=...&anno=...).
 *
 * Props:
 *   selected: Set<number> (cods)
 *   onClear: () => void
 *   label: string  - etichetta sorgente (es. "Curriculum P1 — 2025/26")
 *   anno: number   - anno scolastico contesto
 *   show: bool     - mostra/nascondi (default true)
 */
export default function AlunniSendBar({ selected, onClear, label, anno, show = true }) {
  const navigate = useNavigate();
  const n = selected ? selected.size : 0;
  if (!show) return null;
  if (n === 0) return null;
  const inviaMail = () => {
    const cods = Array.from(selected).join(",");
    const params = new URLSearchParams();
    params.set("codes", cods);
    if (label) params.set("label", label);
    if (anno) params.set("anno", String(anno));
    navigate(`/g/comunicator/comunicator?${params.toString()}`);
  };
  return (
    <div data-testid="alunni-send-bar"
         style={{
           position: "sticky", top: 0, zIndex: 30,
           background: "linear-gradient(90deg,#6a1b9a,#8e24aa)",
           color: "white", padding: "8px 14px", marginBottom: 8,
           display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap",
           boxShadow: "0 2px 8px rgba(0,0,0,0.18)", borderRadius: 3,
         }}>
      <span style={{ background: "white", color: "#6a1b9a", padding: "2px 10px", borderRadius: 12, fontSize: 12, fontWeight: 800 }}>
        ✓ {n} selezionati
      </span>
      {label && <span style={{ fontSize: 11, opacity: 0.92 }}>da <b>{label}</b></span>}
      <div style={{ flex: 1 }} />
      <button onClick={inviaMail}
              data-testid="alunni-send-bar-invia"
              style={{ padding: "6px 14px", background: "white", color: "#6a1b9a", border: "none", fontSize: 12, fontWeight: 800, cursor: "pointer", borderRadius: 3 }}>
        📧 Invia mail ({n})
      </button>
      <button onClick={onClear}
              data-testid="alunni-send-bar-clear"
              title="Deseleziona tutti"
              style={{ padding: "4px 10px", background: "transparent", color: "white", border: "1px solid rgba(255,255,255,0.6)", fontSize: 11, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>
        ✕ Reset
      </button>
    </div>
  );
}
